import type { ContentRelationshipField, FilledContentRelationshipField, Content } from "@prismicio/client"

import type { Nullable } from "@bounce/util"

export const isValidContentRelationship = <TContentType extends Content.AllDocumentTypes["type"]>(
  item: ContentRelationshipField<TContentType>,
): item is FilledContentRelationshipField<
  TContentType,
  string,
  Extract<Content.AllDocumentTypes, { type: TContentType }>["data"]
> => "isBroken" in item && !item.isBroken

export const getValidContentRelationship = <TContentType extends Content.AllDocumentTypes["type"]>(
  item: Nullable<ContentRelationshipField<TContentType>>,
) => (item && isValidContentRelationship(item) ? item : null)
